class ClipboardDirective
  @$inject: ["toasty"]
  constructor: (toasty)->
    class Clipboard
      link: ($scope, $element, attrs)->
        Module = require("clipboard")
        new Module($element[0])
        $element.click ()->
          toasty.success
            title: attrs.title
            msg:  attrs.msg
    return new Clipboard()


angular = require('angular')
pkg = angular
  .module 'common.clipboard', []  
  .directive 'clipboard', ClipboardDirective

module.exports = pkg.name


// WEBPACK FOOTER //
// ./src/common/clipboard/index.coffee